import {Component, Input, Output, EventEmitter, inject, OnInit} from '@angular/core';
import {environment} from "projects/store/src/environments/environment";
import {NavigationEnd, NavigationStart, Router} from "@angular/router";

@Component({
  selector: 'app-sidebar',
  templateUrl: './app.sidebar.component.html'
})
export class AppSidebarComponent implements OnInit {
  srcLogo = `assets/images/${environment.global.country.code}/krediya-logo.png`;

  @Input() isOpen: boolean = false;
  @Output() closeSidebar = new EventEmitter<void>();
  private readonly router = inject(Router);


  ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart && this.isOpen) {
        this.sidebarClose();
      }
    })
  }

  sidebarClose() {
    this.closeSidebar.emit();
  }
}
